<span [ngStyle]="style">{{ params?.value | number : '1.2-2' }}</span>